import {
  type ImageConfigComplete,
  imageConfigDefault,
} from "next/dist/shared/lib/image-config";
import { IMAGE_REMOTE_PATTERNS } from "./image-remote-patterns";
import { IMAGE_DEVICE_SIZES, IMAGE_QUALITIES, IMAGE_SIZES } from "./image-sizes";

export const IMAGE_CONTENT_SECURITY_POLICY =
  "default-src 'self'; script-src 'none'; sandbox;";

export const IMAGE_CONFIG = {
  formats: ["image/avif", "image/webp"],
  deviceSizes: [...IMAGE_DEVICE_SIZES],
  imageSizes: [...IMAGE_SIZES],
  minimumCacheTTL: 2678400,
  qualities: [...IMAGE_QUALITIES],
  remotePatterns: [...IMAGE_REMOTE_PATTERNS],
  dangerouslyAllowSVG: true,
  contentDispositionType: "attachment",
  contentSecurityPolicy: IMAGE_CONTENT_SECURITY_POLICY,
} satisfies Partial<ImageConfigComplete>;

export const COMPLETE_IMAGE_CONFIG: ImageConfigComplete = {
  ...imageConfigDefault,
  ...IMAGE_CONFIG,
};
